import { createSlice } from "@reduxjs/toolkit";

// Trimmed from the old `features/payment/paymentslice.js` - that file mixed
// payment-log/filter state (now `_features/payments/state/slice.js`) with
// gateway-credentials state. Only the credentials half was still live
// anywhere (verified: zero consumers left for `payments`/`totalPrice`/
// `selectedPaymentsFilters` or their reducers) - see docs/bug-sheet.md.
//
// Genuinely shared across 4 features (this one, `integrations`, `pay`,
// `selfServeCheckout`) - they read it as a cross-feature dependency, same
// accepted pattern as other shared slices/API files elsewhere in the app.
const initialState = {
  razorpayCredentials: null,
  stripeCredentials: null,
};

const paymentGatewaySlice = createSlice({
  name: "paymentGateway",
  initialState,
  reducers: {
    setRazorpayCredentials(state, action) {
      state.razorpayCredentials = action.payload;
    },
    setStripeCredentials(state, action) {
      state.stripeCredentials = action.payload;
    },
  },
});

export const { setRazorpayCredentials, setStripeCredentials } =
  paymentGatewaySlice.actions;

export default paymentGatewaySlice.reducer;
